import { identifyUser as identifyAnalyticsUser } from 'analytics';
import { identifyUser as identifyMonitoringUser, isMonitoringEnabled } from 'monitor';
import { useEffect } from 'react';

import { useCurrentUser, useCurrentUserFromAnalyticsCookie } from '../../index';

export const useIdentifyUser = () => {
  const { data: user } = useCurrentUser();
  const userFromAnalytics = useCurrentUserFromAnalyticsCookie();

  useEffect(() => {
    if (user) {
      const {
        id,
        email,
        company,
        full_name,
        is_superuser,
        is_impersonated,
        phone_number,
        is_buyer,
        is_seller,
        country,
        language,
      } = user;

      const data: Record<string, string | number | boolean | Date> = {
        country,
        email: email,
        full_name: full_name,
        is_buyer,
        is_impersonated: is_impersonated,
        is_seller,
        is_superuser: Boolean(is_superuser),
        language,
        phone_number: phone_number || '',
        user_id: id,
      };

      if (company) {
        data.company_id = company.id;
        data.company_name = company.name;
        data.trade_company_id = company.trade_company.id;
        data.trade_company_name = company.trade_company.name;
      }

      identifyAnalyticsUser(email, data);

      if (isMonitoringEnabled()) {
        identifyMonitoringUser({
          ...user,
          id: String(id),
        });
      }
    } else if (userFromAnalytics) {
      identifyAnalyticsUser(userFromAnalytics.email, {
        ...userFromAnalytics,
      });
    }
  }, [user, userFromAnalytics]);
};
